// src/context/AfipHealthProvider.js
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import AfipHealthContext from './AfipHealthContext';
import afipQueueService from '../services/afipQueueService';

const POLL_INTERVAL_MS = 60000;

const AfipHealthProvider = ({ children }) => {
    const [afipHealth, setAfipHealth] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const fetchAfipHealth = useCallback(async () => {
        try {
            const result = await afipQueueService.checkAFIPHealth();
            if (result.success && result.data) {
                setAfipHealth(result.data);
            } else {
                setAfipHealth({ isHealthy: false });
            }
        } catch (error) {
            console.error('Error fetching AFIP health:', error);
            setAfipHealth({ isHealthy: false });
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchAfipHealth();
        const interval = setInterval(fetchAfipHealth, POLL_INTERVAL_MS);
        return () => clearInterval(interval);
    }, [fetchAfipHealth]);

    const contextValue = useMemo(() => ({
        afipHealth,
        isLoading,
        lastUpdated: afipHealth?.timestamp || null,
        refresh: fetchAfipHealth,
    }), [afipHealth, isLoading, fetchAfipHealth]);

    return (
        <AfipHealthContext.Provider value={contextValue}>
            {children}
        </AfipHealthContext.Provider>
    );
};

export default AfipHealthProvider;
